import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

let cache = null;
function loadUoms() {
  if (!cache) cache = api.get("/masters/uom").then(({ data }) => (data || []).filter((u) => u.is_active !== false)).catch(() => []);
  return cache;
}

/**
 * Dropdown of units from Masters → Units of Measure.
 * Default: value is the unit code (e.g. "NOS", "M3") — used by WBS forms.
 * Pass byId to key on the unit's id instead (a real uuid) — used by Service
 * Requisition / Work Order / Purchase Order lines, whose uom_id column is a
 * foreign key, not a code.
 */
export function UomSelect({ value, onChange, className, testId, byId = false }) {
  const [uoms, setUoms] = useState([]);
  useEffect(() => { loadUoms().then(setUoms); }, []);
  const key = (u) => (byId ? u.id : u.code);
  const known = uoms.some((u) => key(u) === value);
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger className={className} data-testid={testId}><SelectValue placeholder="Unit" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">—</SelectItem>
        {value && !known && <SelectItem value={value}>{value}</SelectItem>}
        {uoms.map((u) => <SelectItem key={u.id} value={key(u)}>{u.code}{u.name && u.name !== u.code ? ` — ${u.name}` : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
